<template>
  <div class="container is-fluid">
    <div class="content content-padding">

      <div class="title-with-selector h1-selector">
        <h1 class="title">{{ menu ? menu.languages[0].pivot.name : null }}</h1>
        <state-selector :selected="menu ? parseInt(menu.state_id) : null" 
                        :target="menu"
                        update="menu-slides"
        ></state-selector>
      </div>

        <div class="columns is-multiline">
          <div class="column is-3">
            <b>Texto do Botão [PT]</b><br/>
            <div>{{ menu.parent_languages ? menu.parent_languages[0].pivot.popup_button : null }}</div>
            <div class="placeholder-slide-text" v-if="menu.parent_languages && !menu.parent_languages[0].pivot.popup_button">não definido</div>
          </div>
          <div class="column is-3">
            <b>Texto do Botão [EN]</b><br/>
            <div>{{ menu.parent_languages ? menu.parent_languages[1].pivot.popup_button : null }}</div>
            <div class="placeholder-slide-text" v-if="menu.parent_languages && !menu.parent_languages[1].pivot.popup_button">não definido</div>
          </div>
          <div class="column is-3">
            <b>Texto do Botão [ES]</b><br/>
            <div>{{ menu.parent_languages ? menu.parent_languages[2].pivot.popup_button : null }}</div>
            <div class="placeholder-slide-text" v-if="menu.parent_languages && !menu.parent_languages[2].pivot.popup_button">não definido</div>
          </div>
          <div class="column is-3">
            <b>Texto do Botão [FR]</b><br/>
            <div>{{ menu.parent_languages ? menu.parent_languages[3].pivot.popup_button : null }}</div>
            <div class="placeholder-slide-text" v-if="menu.parent_languages && !menu.parent_languages[3].pivot.popup_button">não definido</div>
          </div>
          <div class="column is-3">
            <b>Título do Grupo [PT]</b><br/>
            <div>{{ menu.parent_languages ? menu.languages[0].pivot.name : null }}</div>
            <div class="placeholder-slide-text" v-if="menu.parent_languages && !menu.languages[0].pivot.name">não definido</div>
          </div>
          <div class="column is-3">
            <b>Título do Grupo [EN]</b><br/>
            <div>{{ menu.parent_languages ? menu.languages[1].pivot.name : null }}</div>
            <div class="placeholder-slide-text" v-if="menu.parent_languages && !menu.languages[1].pivot.name">não definido</div>
          </div>
          <div class="column is-3">
            <b>Título do Grupo [ES]</b><br/>
            <div>{{ menu.parent_languages ? menu.languages[2].pivot.name : null }}</div>
            <div class="placeholder-slide-text" v-if="menu.parent_languages && !menu.languages[2].pivot.name">não definido</div>
          </div>
          <div class="column is-3">
            <b>Título do Grupo [FR]</b><br/>
            <div>{{ menu.parent_languages ? menu.languages[3].pivot.name : null }}</div>
            <div class="placeholder-slide-text" v-if="menu.parent_languages && !menu.languages[3].pivot.name">não definido</div>
          </div>
        </div>

        <div class="columns">
          <div class="column is-one-quarter">
            <div>
              <b>Cor de Fundo</b><br/>
              <div class="flex-container-center">
                {{menu.background_color}}
                <div class="color-preview" v-bind:style="{ backgroundColor: menu.background_color }"></div>
              </div>
            </div>
          </div>
          <div class="column is-one-quarter">
            <div>
              <b>Cor Caixa de Texto</b><br/>
              <div class="flex-container-center">
                {{menu.textbox_color}}
                <div class="color-preview" v-bind:style="{ backgroundColor: menu.textbox_color }"></div>
              </div>
            </div>
          </div>
          <div class="column is-one-quarter">
            <div>
              <b>Cor do Texto</b><br/>
              <div class="flex-container-center">
                {{menu.text_color}}
                <div class="color-preview" v-bind:style="{ backgroundColor: menu.text_color }"></div>
              </div>
            </div>
          </div>
        </div>

        <div class="columns is-multiline" v-if="menu.slug !== 'panorama'">
          <div class="column is-12" v-if="menu.background_path_1">
            <span><b>Background 1</b></span>
            <figure class="image coach-image">
              <img :src="coachImagePath + menu.background_path_1">
            </figure>
          </div>
          <div class="column is-12" v-if="menu.background_path_2">
            <span><b>Background 2</b></span>
            <figure class="image coach-image">
              <img :src="coachImagePath + menu.background_path_2">
            </figure>
          </div>
        </div>

        <a class="button is-primary" @click="openSlideSetEditModal">
          <span class="icon">
            <i class="fa fa-edit"></i>
          </span>
          <span>Editar</span>
        </a>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import SlideSetEditModal from './SlideSetEditModal'
  import StateSelector from '../Util/StateSelector'
  import { BACKGROUND_IMG_PATH } from '../../config'

  const SlideSetEditModalComponent = Vue.extend(SlideSetEditModal)

  export default {
    components: {
      StateSelector
    },

    props: ['menu', 'title'],

    data () {
      return {
        coachId: this.$store.state.route.params.id,
        categoryId: this.$store.state.route.params.cat,
        coachImagePath: BACKGROUND_IMG_PATH
      }
    },

    mounted () {
    },

    computed: {
      currentEvent () {
        return window.store.state.event.nextEvent
      }
    },

    methods: {
      openSlideSetEditModal () {
        let openCardModal = (propsData = {}) => {
          return new SlideSetEditModalComponent({
            el: document.createElement('div'),
            propsData
          })
        }

        openCardModal({
          title: 'Editar Características dos Sub-Slides',
          coach_id: parseInt(this.coachId),
          menu_id: parseInt(this.categoryId),
          parent_slide_id: null,
          categoryData: this.menu
        })
      }
    },

    watch: {
      currentEvent: function (val) {
      }
    }
  }
</script>

<style lang="scss">
</style>


// WEBPACK FOOTER //
// SubMenuInfo.vue?5d797200